import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryOverview from './components/CategoryOverview';
import LatestUpdates from './components/LatestUpdates';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '国产在线·精选内容平台官方入口',
    description: '国产在线汇聚海量优质国产内容资源，高清流畅播放，无需下载即可在线观看。覆盖多元题材，极致的国产在线视听体验。',
    url: 'https://guochanzx.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '国产在线',
      url: 'https://guochanzx.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedArticles />
          <CategoryOverview />
          <LatestUpdates />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}